module.exports = __webpack_public_path__ + "static/media/7-8.e5607549.mp3";